// extracted by mini-css-extract-plugin
export default {"shhWrapper":"styles_shhWrapper__uey50","shhWrapperActive":"styles_shhWrapperActive__QJg+p"};